
import { Component, OnInit } from '@angular/core';

import { AuthService } from '../../../../feature/login/services/auth.service';
import {ActivatedRoute, Router} from "@angular/router";
import {CookieService} from "ngx-cookie-service";
@Component({
  selector: 'app-social-auth-2',
  templateUrl: './social-auth-2.component.html',
  styleUrls: ['./social-auth-2.component.scss']
})
export class SocialAuth2Component implements OnInit {

  constructor(
    private readonly cookieService: CookieService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly authService: AuthService,
    private readonly router: Router
  ) { }

  ngOnInit() {
    const token = this.cookieService.get('social-authentication');
    if (token) {
      this.authService.loginUsingToken(token);
      this.cookieService.delete('social-authentication');
      this.router.navigate(['']);
    }
  }

}
